import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function FullscreenIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M4 8L4 5.42188L7.59375 9.01562L9.00781 7.60156L5.40625 4H8V2H2V8H4Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M4 16.0156L4 18.5938L7.59375 15L9.00781 16.4141L5.40625 20.0156H8V22.0156H2V16.0156H4Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M20.0078 8V5.42188L16.4141 9.01562L15 7.60156L18.6016 4H16.0078V2H22.0078V8H20.0078Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M20.0078 16.0156V18.5938L16.4141 15L15 16.4141L18.6016 20.0156H16.0078V22.0156H22.0078V16.0156H20.0078Z",
    fill: "currentColor"
  }));
}